import React from 'react';
import { Dropdown, DropdownProps, Image } from 'semantic-ui-react-bpm';
import { ICustomFieldDetail } from '../../../../../../../../../common/custom-field-config/interface/custom-field-detail';
import { IOption } from '../../../../../../../../../common/interface/option';
import { fieldIconBaseOnConfigName } from '../../../../configuration/module/document-list/constant';
import { ITableMobileView } from '../../../interface/table-view';

interface IContentUpperWidgetBig {
  columnOptions: IOption[];
  tableMobileView: ITableMobileView;
  updateTableMobileView: (property: string, value: any) => void;
  index: string;
  columns: ICustomFieldDetail[];
}

const ContentUpperWidgetBig: React.FC<IContentUpperWidgetBig> = (props) => {
  const value = props.tableMobileView.upperField;

  const iconToDisplay = () => {
    if (value) {
      const field = props.columns.find(e => e.id === value);
      if (field && field.configName) {
        const fieldIcon = fieldIconBaseOnConfigName[field.configName];
        return <Image src={fieldIcon.icon} className={`field icon ${field.configName}`} />
      }
    }
    return <i className={`plus circular icon`} />
  }

  return <div className='field-widget'>
    {iconToDisplay()}
    <Dropdown
      className={`input-dropdown ${value ? 'hasValue' : ''}`}
      selectOnBlur={false}
      placeholder='Select Field'
      selection
      clearable
      options={props.columnOptions}
      onChange={(e, target: DropdownProps) => {
        props.updateTableMobileView(props.index, {
          ...props.tableMobileView,
          upperField: target.value
        });
      }}
      value={value}
      text={!value ? 'Select Field' : ''}
    />
  </div>
}

export default ContentUpperWidgetBig;
